import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from '../datenauswertung/DatenauswertungGenerisch';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { fn0nZ, formatNumber } from '../../core/formatter/formatNumber';
import { getStandorte } from '../../helpers/getStandorte';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getStyle } from '../datenauswertung/generisch/DatanauswertungGenerischStyles';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isValid as isValidMaschinen } from '../../main/functions/validData';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { StandorteMaschinen } from '../dateneingabe/detail/StandorteMaschinen';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WpdfText } from './pdf/WpdfText.';
import { WpdfView } from './pdf/WpdfView';

interface DatenauswertungMaschinenUndAnlagenProps extends React.ClassAttributes<any> {
    data: any;
    routing: any;
    standortTid: number;
    standortName: string;
    onRoutingChange: (routing: any) => void;
    jahr?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungMaschinenUndAnlagenState {
    pdfString?: string;
    jahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
    showMaschinenDlg: boolean;
}

export class DatenauswertungMaschinenUndAnlagen extends
    React.Component<DatenauswertungMaschinenUndAnlagenProps, DatenauswertungMaschinenUndAnlagenState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            jahr: this.props.jahr || jahrMax - 1,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined,
            validation: {},
            showMaschinenDlg: false
        };
    }

    private entities: any[] = [
        {
            titel: i18n('Maschinen / Anlagen / Heizung', 'sys'),
            entity: IDs.ENT_MASCHINEN
        }
    ];

    componentDidMount(): void {
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'tid'
            ).getData()
        });
    }

    getValues(): any {
        const jahr = this.state.jahr;
        let sum_strom = 0;
        let sum_waerme = 0;

        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const maschinen: any[] = this.props.data[IDs.ENT_MASCHINEN] || [];
        // const maschinen_jahreswerte: any[] = (this.props.data[IDs.ENT_MASCHINEN_JAHRESWERTE] || [])
        //     .filter((maschine: any ) => isValidMaschinen(maschine, IDs.ENT_MASCHINEN_JAHRESWERTE));
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];
        const strom_total = kennzahlen[jahr] && kennzahlen[jahr].strom_verbrauch_gesamt ? kennzahlen[jahr].strom_verbrauch_gesamt : 0;
        const waerme_total = kennzahlen[jahr] && kennzahlen[jahr].waerme_kwh ? kennzahlen[jahr].waerme_kwh : 0;
        let cnt = 0;
        // console.log('M', maschinen, maschinen_jahreswerte);
        maschinen
            .filter((maschine: any) =>
                (!this.props.standortTid || maschine.standort_tid_orig === this.props.standortTid)
                && (
                    (maschine.status || null) !== 2 || ((maschine.status || null) === 2 && typeof maschine.jahr_status === 'number'
                        && maschine.jahr_status >= jahr)
                )
            )
            .forEach((maschine: any) => {
                const alter = maschine.baujahr && maschine.baujahr > 0 ? jahr - maschine.baujahr : -1;
                const energietraeger = maschine.energiedaten_waerme_energietraeger_tid;
                const isValid: boolean = isValidMaschinen(maschine, IDs.ENT_MASCHINEN, this.props.data);
                const abwaerme = maschine.abwaerme;
                const leistung = maschine.leistung;
                const messwert_unterzaehler = maschine.messwert_unterzaehler;
                const standort = maschine.standort_tid;
                const werte = maschine || {};
                // const werte_last = maschine || {};
                // const werte = maschinen_jahreswerte.find((mjw: any) => mjw.maschinen_tid_orig === maschine.tid && jahr === mjw.jahr)
                //     || maschine || {};
                // const werte_last = maschinen_jahreswerte.find((mjw: any) => mjw.maschinen_tid_orig === maschine.tid && jahr - 1 === mjw.jahr)
                //     || maschine || {};
                if (!isValid && !this.state.validation[maschine.tid]) {
                    return;
                }
                cnt += isValid ? 1 : 0;
                let verbrauch = Object.keys(werte).length
                    ? +messwert_unterzaehler > 0
                        ? +messwert_unterzaehler
                        : (werte.auslastungsfaktor / 100) * werte.betriebszeit_h_tag * werte.betriebszeit_tage_jahr * leistung
                    : 0;
                // if (werte.messwert_unterzaehler && werte_last.messwert_unterzaehler) {
                //     const diff = werte.messwert_unterzaehler - werte_last.messwert_unterzaehler;
                //     if (diff > 0) {
                //         verbrauch = diff;
                //     }
                // }
                let anteil = 0;
                if (energietraeger === 'Strom' && strom_total > 0) {
                    anteil = 100 * verbrauch / strom_total;
                } else if (energietraeger !== 'Strom' && waerme_total > 0) {
                    anteil = 100 * verbrauch / waerme_total;
                }
                // console.log('ET', energietraeger);
                if (energietraeger && energietraeger.indexOf && energietraeger.indexOf('Strom') >= 0) {
                    sum_strom += isValid ? verbrauch : 0;
                } else {
                    sum_waerme += isValid ? verbrauch : 0;
                }
                // console.log('W: ', werte);
                const row = [
                    cnt, standort,
                    maschine.name,
                    alter < 0
                        ? '-'
                        : (alter === 0
                            ? `< 1 ${i18n('Jahr', 'sys')}`
                            : (alter === 1 ? `1 ${i18n('Jahr', 'sys')}` : `${alter} ${i18n('Jahre', 'sys')}`)
                        ),
                    leistung > 0 ? `${formatNumber(leistung, 2)} kW` : '-',
                    i18n(energietraeger, 'sys'),
                    verbrauch && verbrauch > 0 ? `${formatNumber(verbrauch, 2)} kWh` : '-',
                    fn0nZ(anteil) + (anteil > 0 ? '%' : ''),
                    abwaerme > 0 ? `${abwaerme}°` : '-'
                ];
                if (this.props.standortTid) {
                    row.splice(1, 1);
                }
                const row_length: number = row.length;
                const isWebForced: boolean = !!(!isValid && this.state.validation[maschine.tid]);
                rows.push(
                    [
                        <div data-text={isValid ? row[0] : ' '}>
                            <div>{isValid ? row[0] : <>&nbsp;</>}</div>
                            {this.state.validation[maschine.tid] &&
                                <ValidierungHinweise
                                    entities={this.entities}
                                    id={maschine.tid}
                                    showPriorityColors
                                    validation={this.state.validation}
                                />
                            }
                        </div>,
                        ...[...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                    ]
                );
                custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
                row_web_forced.push(isWebForced);
            });
        return { rows, diag1, diag2, sum_strom, sum_waerme, strom_total, waerme_total, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        // const lineColor = ['#4f81bd', '#f79646', '#87bd51', '#51bd75', '#5163bd', '#9951bd', '#bd5175', '#bd5151'];
        // const style: any = { sub: getStyle('sub') };
        // const totalWidth = 13 * 60; // Das war die Ausgangsbasis
        const numCols = 8 + (this.props.standortTid ? 0 : 3);
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const config: any = {
            titel0: unternehmen,
            titel1: i18n('Auswertung Maschinen / Anlagen / Heizung', 'sys'),
            titel2: this.props.standortName,
            filename: `${i18n('Auswertung', 'sys')}_${i18n('Maschinen', 'sys')}_${i18n('Anlagen', 'sys')}_${this.state.jahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'maschinen' },
            baseWidth: baseWidth,
            header: {
                blocks: [
                    {
                        label: i18n('Energieverbraucher', 'sys'),
                        width: `${baseWidth * (4 + (this.props.standortTid ? 0 : 3))}%`,
                        columns: [
                            { label: i18n('Nr', 'sys'), customStyleLabel: { fontSize: 8 }, customStyleColumn: { flexGrow: '0.5' } },
                            { label: i18n('Standort', 'sys'), customStyleColumn: { flexGrow: '3', paddingRight: '1pt' } },
                            { label: i18n('Anlage / Teil', 'sys'), customStyleColumn: { flexGrow: '1.5' } },
                            { label: i18n('Alter', 'sys') },
                            { label: i18n('Kapazität', 'sys') }
                        ]
                    },
                    {
                        label: i18n('Eingesetzte Energie', 'sys'),
                        width: `${baseWidth * 2}%`,
                        columns: [
                            { label: i18n('Energieträger', 'sys') },
                            { label: `${i18n('Energie', 'sys')} [kWh]` }
                        ]
                    },
                    {
                        label: i18n('Anteil{{lb}}Verbrauch', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`
                    },
                    {
                        // label: 'Abwärme \n (Temperatur- \n niveau)',
                        label: `${i18n('Abwärme', 'sys')} (${i18n('Temperatur-{{lb}}niveau', 'sys').replace('{{lb}}', '\n')})`,
                        width: `${baseWidth}%`,
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header'],
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            rows_width: [baseWidth * 0.5, baseWidth * 3, baseWidth * 1.5],
            diagrams: []
        };
        if (this.props.standortTid) {
            config.header.blocks[0].columns.splice(1, 1);
            config.rows_width.splice(1, 1);
        }
        config.values = values;
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label='Datenauswertung - Hinweise'
                helpKey='datenauswertung_maschinen'
                type='info'
                editBar
            />
        );

                const arr_header_form_elements: any[] = [
                    {
                        elem: <DatenauswertungJahrauswahlEinzeln
                            jahrMax={this.state.jahrMax}
                            jahrMin={this.state.jahrMin}
                            jahr={this.state.jahr}
                            onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                            renderClean={true}
                        />,
                        wrapClass: 'datenauswertungContentLeft'
                    },
                    {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                        wrapClass: 'datenauswertungContentGrow'
                    },
                    { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
                    { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
                    { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
                    { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
                ];
        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahlEinzeln
                            jahrMax={this.state.jahrMax}
                            jahrMin={this.state.jahrMin}
                            jahr={this.state.jahr}
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    funcExternalElementUnderTable={(isPdf: boolean, vals: any) => this.getAuswertung(isPdf, vals, baseWidth)}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
                {this.state.showMaschinenDlg && this.renderMaschinenDlg()}
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='maschinen'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const data: any = this.props.data || {};
        const isGefuehrterModus: boolean = (data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.gefuehrter_modus_orig === 1);
        const standorte: any[] = (getStandorte(data) || []).map((standort: any) => standort.tid);
        const index: number = standorte.indexOf(this.props.standortTid);
        const path: any = isGefuehrterModus
            ? RoutingIDs.ROUTE_DATENEINGABE
            : {
                ...RoutingIDs.ROUTE_DATENEINGABE_MASCHINEN_ANLAGEN,
                [RoutingIDs.TABS_DATENEINGABE_MASCHINEN]: index === -1 ? 0 : index,
                terminateOn: RoutingIDs.TABS_DATENEINGABE_MASCHINEN
            };
        const konfig = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0];
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => {
                    if (konfig && (konfig.gefuehrter_modus === 'Ja' || konfig.gefuehrter_modus === 1)) {
                        this.setState({ showMaschinenDlg: true });
                    } else {
                        this.props.onRoutingChange({ path })
                    }
                }}
            />
        );
    }

    // renderAssistentDlg() {
    //     const { data, standortTid, routing, onRoutingChange } = this.props;
    //     const { jahr } = this.state;
    //     return <div style={{ width: 1000 }}>
    //         <DialogWrapper2
    //             onAfterClose={() => this.setState({ showAssistentDlg: false })}
    //             left={0}
    //         >
    //             <Assistent
    //                 data={data}
    //                 jahrPreset={jahr}
    //                 standortPreset={standortTid}
    //                 dialogMode={true}
    //                 // onRoutingChange={onRoutingChange}
    //                 onRoutingChange={() => { }}
    //                 routing={routing}
    //             />
    //         </DialogWrapper2>
    //     </div>;
    // }

    renderMaschinenDlg(): JSX.Element {
        const { data, standortTid } = this.props;
        let standort;
        if (standortTid > 0) {
            standort = (data[IDs.ENT_STANDORT] || []).find((s: any) => s.tid === standortTid);
        }
        return <div>
            <DialogWrapper2
                title={i18n('Dateneingabe: Maschinen / Anlagen / Heizung', 'sys')}
                width={-1}
                onAfterClose={() => this.setState({ showMaschinenDlg: false })}
            >
                <div style={{ maxWidth: window.innerWidth - 60, overflow: 'auto' }}>
                    <StandorteMaschinen
                        data={data}
                        onRoutingChange={() => { }}
                        routing={{}}
                        standortSelected={standort}
                    />
                </div>
            </DialogWrapper2>
        </div>;
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasMaschinen);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_MASCHINEN_ANLAGEN_HEIZUNG, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }

    getAuswertung(isPdf: boolean, values: any, baseWidth: number): JSX.Element {
        const proz_waerme = (values.waerme_total > 0) && (values.sum_waerme / values.waerme_total * 100);
        const proz_strom = (values.strom_total > 0) && (values.sum_strom / values.strom_total * 100);
        const proz_waerme_str = !isNaN(proz_waerme) && proz_waerme > 0 ? `${fn0nZ(proz_waerme)}%` : '';
        const proz_strom_str = !isNaN(proz_strom) && proz_strom > 0 ? `${fn0nZ(proz_strom)}%` : '';
        const flexCol = { width: `${baseWidth}%`, display: 'flex', flexDirection: 'column' };
        const spaceLeft = `${baseWidth * (this.props.standortTid ? 0.5 : 3.5)}%`;

        return (
            <WpdfView pdf={isPdf} style={{ ...getStyle('main', isPdf), paddingTop: isPdf ? 8 : 10, boxRadius: 'none', boxShadow: 'none' }}>
                <WpdfView pdf={isPdf} style={{ ...getStyle('rows_main', isPdf) }}>
                    <WpdfView pdf={isPdf} style={{ flexDirection: 'column' }}>
                        <WpdfView pdf={isPdf} style={{ ...getStyle('row', isPdf) }}>
                            <WpdfView
                                pdf={isPdf}
                                style={{ ...getStyle('row_field', isPdf), backgroundColor: 'white', width: spaceLeft, borderTop: 0 }}
                            />
                            <WpdfView pdf={isPdf} style={{ ...flexCol, width: `${baseWidth * 4.5}%` }}>
                                <WpdfView
                                    pdf={isPdf}
                                    style={{ ...getStyle('row_field', isPdf), textAlign: 'left', paddingLeft: 2, borderTop: 0 }}
                                >
                                    <WpdfText pdf={isPdf}>
                                        {i18n('STROM - Verbrauch laut Anlagenliste (vgl. oben)', 'sys')}
                                    </WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView
                                    pdf={isPdf}
                                    style={{ ...getStyle('row_field', isPdf), textAlign: 'right', paddingRight: 2, borderTop: 0 }}
                                >
                                    <WpdfText pdf={isPdf}>{fn0nZ(values.sum_strom)} kWh</WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'center', borderTop: 0 }}>
                                    <WpdfText pdf={isPdf}>{proz_strom_str}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView pdf={isPdf} style={{ ...getStyle('row', isPdf) }}>
                            <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), backgroundColor: 'white', width: spaceLeft }} />
                            <WpdfView pdf={isPdf} style={{ ...flexCol, width: `${baseWidth * 4.5}%` }}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'left', paddingLeft: 2 }}>
                                    <WpdfText pdf={isPdf} style={{ fontStyle: 'italic' }}>
                                        {i18n('STROM - Tatsächlicher Verbrauch (laut Rechnungen)', 'sys')}
                                    </WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'right', paddingRight: 2 }}>
                                    <WpdfText pdf={isPdf}>{fn0nZ(values.strom_total)} kWh</WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'center' }}>
                                    <WpdfText pdf={isPdf}>100%</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView pdf={isPdf} style={{ ...getStyle('row', isPdf), paddingTop: isPdf ? 13 : 20 }}>
                            <WpdfView
                                pdf={isPdf}
                                style={{ ...getStyle('row_field', isPdf), backgroundColor: 'white', width: spaceLeft, borderTop: 0 }}
                            />
                            <WpdfView pdf={isPdf} style={{ ...flexCol, width: `${baseWidth * 4.5}%` }}>
                                <WpdfView
                                    pdf={isPdf}
                                    style={{ ...getStyle('row_field', isPdf), textAlign: 'left', paddingLeft: 2, borderTop: 0 }}
                                >
                                    <WpdfText pdf={isPdf}>
                                        {i18n('WÄRME - Verbrauch laut Anlagenliste (vgl. oben)', 'sys')}
                                    </WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView
                                    pdf={isPdf}
                                    style={{ ...getStyle('row_field', isPdf), textAlign: 'right', paddingRight: 2, borderTop: 0 }}
                                >
                                    <WpdfText pdf={isPdf}>{fn0nZ(values.sum_waerme)} kWh</WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'center', borderTop: 0 }}>
                                    <WpdfText pdf={isPdf}>{proz_waerme_str}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView pdf={isPdf} style={{ ...getStyle('row', isPdf) }}>
                            <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), backgroundColor: 'white', width: spaceLeft }} />
                            <WpdfView pdf={isPdf} style={{ ...flexCol, width: `${baseWidth * 4.5}%` }}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'left', paddingLeft: 2 }}>
                                    <WpdfText pdf={isPdf} style={{ fontStyle: 'italic' }}>
                                        {i18n('WÄRME - Tatsächlicher Verbrauch (laut Rechnungen)', 'sys')}
                                    </WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'right', paddingRight: 2 }}>
                                    <WpdfText pdf={isPdf}>{fn0nZ(values.waerme_total)} kWh</WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView pdf={isPdf} style={flexCol}>
                                <WpdfView pdf={isPdf} style={{ ...getStyle('row_field', isPdf), textAlign: 'center' }}>
                                    <WpdfText pdf={isPdf}>100%</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }
}
